// Hero — left copy, right product shot (kanban miniature)
const Hero = () => (
  <section className="hero section">
    <div className="container hero-grid">
      <div className="hero-copy">
        <h1>
          Från nya <span style={{ color: "var(--primary)" }}>affärer</span> till ökad <span style={{ color: "var(--primary)" }}>vinst</span>.
        </h1>
        <p className="lede" style={{ marginTop: 24 }}>
          Byggro håller ordning och hjälper dig räkna på dina affärer, projekt och leveranser — innan jobbet är klart, inte efter.
        </p>
        <div style={{ display: "flex", gap: 12, marginTop: 36 }}>
          <a href="#demo" className="btn btn-primary">Boka demo<span className="arr" /></a>
          <a href="#produkt" className="btn btn-secondary">
            Se produkten
          </a>
        </div>
        <div className="hero-meta">
          <span className="chip">
            <span className="chip-dot" />
            Prova fritt i 30 dagar
          </span>
          <span style={{ fontSize: 13, color: "var(--ink-3)" }}>Inget krav på betalkort · Ingen bindningstid.</span>
        </div>
      </div>
      <div className="hero-product">
        <HeroProductShot />
      </div>
    </div>
  </section>
);

// Mini kanban product shot — feels like a real screenshot but tighter than full lead inbox
const HeroProductShot = () => (
  <div className="product-shot">
    <div className="ps-chrome">
      <div style={{ display: "flex", gap: 6 }}>
        <span className="ps-dot" />
        <span className="ps-dot" />
        <span className="ps-dot" />
      </div>
      <div className="ps-url mono">app.byggro.se / affärer</div>
      <div style={{ width: 48 }} />
    </div>
    <div className="ps-body">
      <div className="ps-toolbar">
        <div style={{ display: "flex", gap: 6 }}>
          <span className="seg-btn active sm">Alla 16</span>
          <span className="seg-btn sm">Mina 9</span>
        </div>
        <span className="seg-btn primary sm">+ Ny affär</span>
      </div>
      <div className="ps-kanban">
        <PSCol
          title="Inkomna"
          count={8}
          dot="var(--ink-3)"
          cards={[
            { name: "Familjen Lindqvist", t: "Tillbyggnad · Lidingö", v: "420 000" },
            { name: "BRF Solrosen", t: "Fasadrenovering", v: "1.2 M" },
            { name: "Anders Berg", t: "Badrum · Bromma", v: "185 000" },
          ]}
        />
        <PSCol
          title="Kontaktade"
          count={5}
          dot="var(--accent-amber)"
          cards={[
            { name: "Sundberg Fastigh.", t: "Takbyte · 320 m²", v: "680 000", followup: "Platsbesök tor" },
            { name: "Johan & Mia Ek", t: "Kök · Bromma", v: "310 000" },
          ]}
        />
        <PSCol
          title="Offert skickad"
          count={3}
          dot="var(--primary)"
          cards={[
            { name: "Villa Tegelbacken", t: "Altan + uterum", v: "245 000", warm: true },
            { name: "Café Norrlyckan", t: "Lokalanpassning", v: "890 000" },
          ]}
        />
      </div>
    </div>
    <div className="ps-tooltip">
      <div style={{ fontSize: 11, fontFamily: "var(--font-mono)", color: "var(--ink-4)", textTransform: "uppercase", letterSpacing: "0.08em" }}>Pipeline</div>
      <div style={{ fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 600, marginTop: 2, letterSpacing: "-0.02em" }}>
        <span className="tnum">3.95 M</span>
        <span style={{ fontSize: 13, color: "var(--ink-3)", fontWeight: 400, marginLeft: 4 }}>kr</span>
      </div>
      <div style={{ fontSize: 11.5, color: "var(--accent-green)", marginTop: 2 }}>+18 % mot förra månaden</div>
    </div>
  </div>
);

const PSCol = ({ title, count, dot, cards }) => (
  <div className="ps-col">
    <div className="ps-col-head">
      <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
        <span style={{ width: 6, height: 6, borderRadius: 99, background: dot }} />
        <span style={{ fontSize: 11.5, fontWeight: 600 }}>{title}</span>
        <span style={{ fontFamily: "var(--font-mono)", fontSize: 10.5, color: "var(--ink-4)" }}>{count}</span>
      </span>
    </div>
    {cards.map((c, i) => (
      <div key={i} className={`ps-card ${c.hot ? "hot" : ""} ${c.warm ? "warm" : ""}`}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 6 }}>
          <div className="ps-name" style={{ fontSize: 11.5, fontWeight: 600 }}>
            {c.name}
          </div>
          {c.hot && (
            <span className="hot-tag sm" style={{ flexShrink: 0 }}>
              HOT
            </span>
          )}
        </div>
        <div style={{ fontSize: 10.5, color: "var(--ink-3)", marginTop: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{c.t}</div>
        <div className="mono" style={{ fontSize: 10.5, marginTop: 6, fontWeight: 500, whiteSpace: "nowrap" }}>
          {c.v} kr
        </div>
        {c.followup && <div className="ps-fu">● {c.followup}</div>}
      </div>
    ))}
  </div>
);

Object.assign(window, { Hero });
